module.exports = __webpack_public_path__ + "media/country_flags/cv-7852fc0c.png";